module.exports = __webpack_public_path__ + "img/image.444a94e2.svg";